import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-ham-sidemenu",
  templateUrl: "./ham-sidemenu.component.html",
})
export class HamSidemenuComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
